import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const BuyeasyGuidanceStepTranslations = wrapTranslationsSchema({
	name: 'BuyEasyGuidanceStepTranslations',
	title: 'Guidance Step Translations',
	sanityId: 'buyeasy-wizardGuidanceStep',
	fields: {
		errorOccurred: 'An error occurred',
	},
});
